import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { setSystemTimeDiff } from "store/app.slice";
import type { RootState } from "store/store";

type FetchBaseQueryArgs = Parameters<typeof fetchBaseQuery>[0];

const SYNC_THRESHOLD_MS = 1000;

export const createBaseQueryWithServerTimeSync = (
  options: FetchBaseQueryArgs
): BaseQueryFn<FetchArgs | string, unknown, FetchBaseQueryError> => {
  const rawBaseQuery = fetchBaseQuery(options);
  return async (args, api, extraOptions) => {
    const result = await rawBaseQuery(args, api, extraOptions);
    const serverTime = result.meta?.response?.headers?.get("date");
    if (serverTime) {
      const parsed = new Date(serverTime).getTime();
      if (Number.isFinite(parsed)) {
        const diff = parsed - Date.now();
        const currentDiff = (api.getState() as RootState).app.systemTimeDiff;
        if (Math.abs(diff - currentDiff) > SYNC_THRESHOLD_MS) {
          api.dispatch(setSystemTimeDiff({ systemTimeDiff: diff }));
        }
      }
    }
    return result;
  };
};
